import { apiRoutes } from "@constants/api-routes";
import { MESSAGE_TEMPLATE_ID_PATTERN } from "@constants/url-parameter-patterns";
import { EntityStatusTypes } from "@enums/entity-status-types";
import { RequestTypes } from "@enums/request-types";
import { MultiLanguageWrapper } from "@iddataweb/idw-common-ui/types";
import { MessageTemplate, MessageTemplatePermissions } from "@idw-types/data/message-template";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";
import { handleRequestWithBody } from "@utils/http-util";
import { injectCustomIdParameter } from "@utils/parameter-injector";

type UpdateMessageTemplateRequestResponse = {
    transferObject: MessageTemplate;
};

export const updateMessageTemplateRequest = async (
    id: string,
    template: string,
    name: string,
    companyId: string,
    rpServiceID: string,
    languages: Partial<MultiLanguageWrapper<string>>,
    status: EntityStatusTypes,
    uuid: string,
    type:string,
    permissions: MessageTemplatePermissions,
    sender:string,
): Promise<GenericNetworkResponse<UpdateMessageTemplateRequestResponse>> => {
    const route = injectCustomIdParameter(apiRoutes.axnadminCore.data.messageTemplateWithId, id, MESSAGE_TEMPLATE_ID_PATTERN);
    const languagesString = JSON.stringify(languages);
    const body: MessageTemplate = {
        id,
        template,
        name,
        rpServiceID: rpServiceID,
        organizationID: companyId, 
        languages: languagesString,
        type,
        status,
        uuid,
        permissions,
        sender,
    };

    const { data, error } = await handleRequestWithBody(RequestTypes.PUT, route, body);
    return { data, error, body };
};